import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[rxFormControlErrorContainer]',
})
export class RxFormControlErrorContainerDirective {
  constructor(public vcr: ViewContainerRef) {}
}
